import { Menu, X } from "lucide-react";
import { cn } from "@/lib/utils";
import { MenuItems } from "./MenuItems";
import { UserProfile } from "./UserProfile";
import { LogoutButton } from "./LogoutButton";

interface SidebarProps {
  isOpen: boolean;
  onToggle: () => void;
  userProfile?: {
    name: string;
    company: string;
    avatar_url?: string;
    role: string;
  };
  currentPath: string;
}

export const Sidebar = ({ isOpen, onToggle, userProfile, currentPath }: SidebarProps) => {
  return (
    <>
      <button
        onClick={onToggle}
        className="fixed top-4 left-4 z-50 p-2 rounded-lg bg-white shadow-md lg:hidden"
      >
        {isOpen ? <X size={24} /> : <Menu size={24} />}
      </button>

      <aside
        className={cn(
          "fixed inset-y-0 left-0 z-40 w-64 bg-white shadow-lg transform transition-transform duration-200 ease-in-out lg:translate-x-0",
          isOpen ? "translate-x-0" : "-translate-x-full"
        )}
      >
        <div className="h-20 flex items-center justify-center border-b">
          <h1 className="text-2xl font-heading font-bold text-primary">ImobControl</h1>
        </div>

        {userProfile && (
          <UserProfile
            name={userProfile.name}
            company={userProfile.company}
            avatarUrl={userProfile.avatar_url}
          />
        )}

        <MenuItems
          role={userProfile?.role || ''}
          currentPath={currentPath}
          onItemClick={() => onToggle()}
        />

        <LogoutButton />
      </aside>
    </>
  );
};